(function () {
  "use strict";

  /**
   * @module newsArticleReadTime
   */
  var initNewsIndex = {};

  /**
   * Initialise News Index
   *
   * @memberof module:newsIndex
   */
  initNewsIndex.init = function () {
    if (QLD.utils.getParamaterByName("tag")) {
      if ($('[data-action="tag-paramater"]').length > 0) {
        var $newsHeader = $('[data-action="tag-paramater"]');
        var tag = QLD.utils.getParamaterByName("tag");
        $(".qld__tag").each(function () {
          const url = new URL(this.getAttribute("href"));
          const searchParams = url.searchParams;

          if (tag === searchParams.get("tag")) {
            $newsHeader.text(this.innerText);
            return false;
          }
        });
      }
    }
  };

  // Assign initNewsIndex to global QLD object of functions
  QLD.initNewsIndex = initNewsIndex;

  document.addEventListener("DOMContentLoaded", initNewsIndex.init);
})();
